/**
 * Keeps the header cart count honest without a page load.
 *
 * The count in cs-header.liquid is rendered server-side from `cart.item_count`,
 * so before this it only ever changed when a new page was served. That was
 * survivable while add-to-cart bounced the customer to /cart; once it stops
 * doing that, a silent header is the only feedback they get, which is none.
 *
 * Horizon's own <cart-icon> does this job for Horizon's bubble, which we render
 * hidden — our badge is our own markup, so it needs its own painter.
 *
 * Loaded from the header, so anything that dispatches the standard cart event
 * is covered: the product form, the sticky bar, quick-add, an app.
 */
(function () {
  const BADGE_CLASS =
    'figures absolute top-0 right-0 min-w-[18px] h-[18px] px-1 inline-flex items-center justify-center bg-primary text-primary-foreground text-[10px] font-bold leading-none';

  /**
   * Paint a count into the header bag. Exposed because cs-cart.js changes the
   * cart through /cart/change.js, which does not dispatch the standard event.
   *
   * @param {number} count
   */
  window.csPaintCartCount = function (count) {
    const trigger = document.querySelector('.cs-cart-trigger a, .cs-cart-trigger button');
    if (!trigger) return;

    let badge = trigger.querySelector('[data-cs-cart-count]') || trigger.querySelector('.bg-primary');

    if (!count) {
      badge?.remove();
      return;
    }

    if (!badge) {
      badge = document.createElement('span');
      badge.className = BADGE_CLASS;
      trigger.appendChild(badge);
    }

    badge.setAttribute('data-cs-cart-count', '');

    // Pulse only on a real change. Repainting the same number — which happens
    // whenever the toast re-reads the cart — should not make the badge twitch.
    const changed = badge.textContent !== String(count);
    badge.textContent = String(count);

    if (!changed) return;
    badge.classList.remove('animate-pulse-once');
    void badge.offsetWidth;
    badge.classList.add('animate-pulse-once');
  };

  document.addEventListener('shopify:cart:lines-update', (event) => {
    // Optimistic event — the promise is what carries the settled cart. Same
    // ordering trap that made add-to-cart drop items: never act on the event.
    event.promise
      ?.then((result) => {
        if (result?.detail?.didError) return;
        const count = result?.cart?.totalQuantity;
        if (typeof count === 'number') window.csPaintCartCount(count);
      })
      .catch(() => {});
  });
})();
